<script setup lang="ts">
const { show, cancel, confirm, loadingCancel, loadingConfirm, descriptionText } = useConfirmModal();

const disableButtons = computed(() => loadingCancel.value || loadingConfirm.value);
</script>

<template>
  <SBModal v-model:show="show" :title="$t('modals.confirm.title')" :dismissable="true" class="min-w-sm" @close="cancel()">
    <div class="flex flex-col gap-4">
      <p class="text-neutral-600">
        {{ descriptionText || $t('modals.confirm.defaultMessage') }}
      </p>

      <div class="flex self-end gap-4">
        <SBButton
          :loading="loadingCancel"
          :label="$t('common.cancel')"
          variant="ghost"
          :disabled="disableButtons"
          @click="cancel()"
        />

        <SBButton
          :loading="loadingConfirm"
          :disabled="disableButtons"
          :label="$t('common.confirm')"
          @click="confirm()"
        />
      </div>
    </div>
  </SBModal>
</template>
